import { render, staticRenderFns } from "./VoyageReportForm.vue?vue&type=template&id=170c8366&"
import script from "./VoyageReportForm.vue?vue&type=script&lang=js&"
export * from "./VoyageReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports